import { boolean, number, object, ObjectSchema } from 'yup'
import { ImagesFormValidationData } from '../../models/images'

const useImageValidation = (): {
  inProgressValidationSchema: ObjectSchema<ImagesFormValidationData>
  finalValidationSchema: ObjectSchema<ImagesFormValidationData>
} => {
  const inProgressValidationSchema = object().shape({
    images: object().shape({
      complete: object().shape({
        id: number(),
        required: boolean().required(),
      }),
      batteries: object().shape({
        id: number(),
        required: boolean().required(),
      }),
      connection: object().shape({
        id: number(),
        required: boolean().required(),
      }),
      'power-inverter': object().shape({
        id: number(),
        required: boolean().required(),
      }),
      'battery-box': object().shape({
        id: number(),
        required: boolean().required(),
      }),
    }),
  })

  const finalValidationSchema: ObjectSchema<ImagesFormValidationData> = object().shape({
    images: object().shape({
      complete: object().shape({
        id: number().required(),
        required: boolean().required(),
      }),
      batteries: object().shape({
        id: number().required(),
        required: boolean().required(),
      }),
      connection: object().shape({
        id: number().required(),
        required: boolean().required(),
      }),
      'power-inverter': object().shape({
        id: number(),
        required: boolean().required(),
      }),
      'battery-box': object().shape({
        id: number(),
        required: boolean().required(),
      }),
    }),
  })

  return { inProgressValidationSchema, finalValidationSchema }
}

export default useImageValidation
